import { ProductVariantResource } from '@/api/serverApi'
import TBoltOptionType from '@/components/3d/product-picker/components/product-configuration-table/types/TBoltOptionType'
import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

export type ProductPickerStateType = {
  selectedProduct?: ProductVariantResource
  selectedProductConfigurationOption?: TBoltOptionType
}

const initialState: ProductPickerStateType = {
  selectedProduct: undefined,
  selectedProductConfigurationOption: undefined,
}

export const productPickerSlice = createSlice({
  name: 'product-picker-state',
  initialState,
  reducers: {
    setSelectedProduct: (state, action: PayloadAction<ProductVariantResource>) => {
      const isSameProduct = state.selectedProduct?.id === action.payload.id
      const isCastInAnchorChannel = action.payload.product_type === 'cast_in_anchor_channel'

      if (isCastInAnchorChannel && !isSameProduct) {
        const isCompatibleConfigurationOption = state.selectedProductConfigurationOption?.productVariant?.id === action.payload.compatible_children[0].id

        if (!isCompatibleConfigurationOption) {
          state.selectedProductConfigurationOption = {
            productVariant: action.payload.compatible_children[0],
            diameter: action.payload.compatible_children[0].t_bolt!.diameters[0],
          }
        }
      }

      state.selectedProduct = action.payload

    },
    setSelectedProductConfigurationOption: (state, action: PayloadAction<TBoltOptionType>) => {
      state.selectedProductConfigurationOption = action.payload
    },
    clearSelectedProduct: (state) => {
      state.selectedProduct = undefined
      state.selectedProductConfigurationOption = undefined
    },
  },
})

export const { setSelectedProduct, setSelectedProductConfigurationOption, clearSelectedProduct } = productPickerSlice.actions

export default productPickerSlice.reducer
